var scrollToEl = function($el, offset, time, onStopCallback) {
	var $ = jQuery;
	var animation;
	var scrollOffset = $('body').data('offset');
	var hold = function() {
		if(animation)
		{
			animation.stop();
		}
		$(document).off('mousewheel', hold);
		$(document).off('touchmove', hold);
		if(onStopCallback) {
			onStopCallback();
		}
	};
	
	if(!time)
	{
		time = 1000;
	}
	
	if(!offset)
	{
		offset = 0;
	}
	
	if(scrollOffset > 0)
	{
		offset += scrollOffset-1;
	}
	
	$(document).on('mousewheel', hold);
	$(document).on('touchmove', hold);
	animation = $('body,html').animate({
        scrollTop: $el.offset().top-offset
    }, time, hold);
};